function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { isValidElement, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../utils/classNames';

var Option = function Option(_ref) {
  var qa = _ref.qa,
      className = _ref.className,
      disabled = _ref.disabled,
      alert = _ref.alert,
      primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText,
      tertiaryText = _ref.tertiaryText;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, 'psw-fill-x', 'psw-l-stack-left', 'psw-t-align-l')
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('psw-t-body', 'psw-c-t-1', 'psw-l-line-left', 'psw-fill-x', _defineProperty({}, classNames('psw-is-disabled'), disabled))
  }, /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#primaryText"),
    className: classNames('psw-t-wrap', 'psw-p-y-1', !!alert && 'psw-m-r-4')
  }, primaryText), !!alert && /*#__PURE__*/isValidElement(alert) && /*#__PURE__*/cloneElement(alert, {
    qa: "".concat(qa, "#alert")
  })), !!secondaryText && /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#secondaryText"),
    className: classNames('psw-fill-x', 'psw-t-overline', 'psw-c-t-2', 'psw-t-wrap', 'psw-m-b-2', _defineProperty({}, classNames('psw-is-disabled'), disabled))
  }, secondaryText), !!tertiaryText && /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#tertiaryText"),
    className: classNames('psw-fill-x', 'psw-t-overline', 'psw-c-t-2', 'psw-t-wrap', _defineProperty({}, classNames('psw-is-disabled'), disabled))
  }, tertiaryText));
};

Option.defaultProps = {
  qa: '',
  className: '',
  disabled: false,
  alert: null,
  secondaryText: '',
  tertiaryText: ''
};
Option.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * whether the option is disabled or not
   */
  disabled: PropTypes.bool,

  /*
   * if you want an alert
   */
  alert: PropTypes.node,

  /**
   * Primary text accepted for option dropdown options
   */
  primaryText: PropTypes.string.isRequired,

  /**
   * Secondary text accepted for option dropdown options
   */
  secondaryText: PropTypes.string,

  /**
   * Tertiary text accepted for option dropdown options
   */
  tertiaryText: PropTypes.string
};
export default Option;